import React from "react";
import styled, { keyframes } from "styled-components";
type prop = {
  width: any;
  mb?: any;
};
const SkeletonAnimation = keyframes`
  0% { background-color: #eee; }
  50% { background-color: #f5f5f5; }
  100% { background-color: #eee; }
`;

const SkeletonWrapper = styled.div`
  display: grid;
  grid-template-columns: 150px auto;
  gap: 10px;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid #e0e0e0;
`;

const SkeletonImage = styled.div`
  width: 150px;
  height: 150px;
  background-color: #eee;
  animation: ${SkeletonAnimation} 1.5s infinite ease-in-out;
  border-radius: 5px;
`;
const SkeletonTextContainer = styled.div`
  display: grid;
  grid-template-rows: auto auto; /* Two rows for text */
  row-gap: 10px;
`;

const SkeletonText = styled.div<prop>`
  width: ${(props) => props.width || "100%"};
  height: 1em;
  background-color: #eee;
  animation: ${SkeletonAnimation} 1.5s infinite ease-in-out;
  border-radius: 3px;
  margin-bottom: ${(props) => props.mb || "0.5em"};
`;

const SkeletonLoader = () => {
  return (
    <>
      {Array.from({ length: 5 }).map((_, index) => (
        <SkeletonWrapper key={index}>
          <SkeletonImage />
          <SkeletonTextContainer>
            <div>
              <SkeletonText width="80%" mb="0.5em" />
              <SkeletonText width="80%" />
              <SkeletonText width="60%" mb="1em" />
            </div>
            <div>
              <SkeletonText width="30%" mb="0.5em" />
              <SkeletonText width="10%" />
            </div>
          </SkeletonTextContainer>
        </SkeletonWrapper>
      ))}
    </>
  );
};

export default SkeletonLoader;
